<script>
import api from '@/command/api'
import TemplateHeaderTable from '@/components/TemplateHeaderTable'
import { resourceHeaderConfig } from '../resource/config'
import { getAction } from '@/command/netTool'

export default {
  name: 'resource-audit',
  components: {},
  data() {
    return {
      ...api.command.getState(),
      paramsValue: {},
      changeLogVisible: false,
      currentResourceId: '',
      // 字典数据
      resourcesTypeList: [],
      landUseNatureList: [],
      recruitmentType: []
    }
  },
  mounted() {
    // 获取字典数据
    this.loadDictData()

    api.command.getList.call(this, {
      url: '/farmHousingResourcesStreetAudit/page',
      current: 1
    })
  },
  methods: {
    // 加载字典数据
    loadDictData() {
      getAction(
        '/admin/dict/codes?codes=housing_resources_type,housing_land_use_nature,recruitment_type',
        {},
        '/bpi'
      ).then(res => {
        if (res.code == 200) {
          // 填充资源类型
          this.resourcesTypeList = (
            res.data['housing_resources_type'] || []
          ).map(item => ({
            name: item.name,
            value: item.id
          }))

          // 填充用地性质
          this.landUseNatureList = (
            res.data['housing_land_use_nature'] || []
          ).map(item => ({
            name: item.name,
            value: item.id
          }))

          this.recruitmentType = (res.data['recruitment_type'] || []).map(
            item => ({
              name: item.name,
              value: item.id
            })
          )

          // 强制重新渲染
          this.$forceUpdate()
        }
      })
    },
    getHeader() {
      return [
        {
          name: '资源名称',
          type: 'input',
          key: 'name',
          placeholder: '请输入资源名称'
        },
        {
          name: '资源类型',
          type: 'select',
          key: 'resourcesType',
          placeholder: '请选择资源类型',
          dictType: 'housing_resources_type',
          typeData: this.resourcesTypeList
        },
        {
          name: '用地性质',
          type: 'select',
          key: 'landUseNature',
          placeholder: '请选择用地性质',
          dictType: 'housing_land_use_nature',
          typeData: this.landUseNatureList
        }
      ]
    },

    getColumns() {
      return [
        ...resourceHeaderConfig.columns.slice(0, -1),
        {
          dataIndex: 'action',
          title: '操作',
          type: 'buttonGroup',
          align: 'center',
          fixed: 'right',
          typeData: ({ records }) => {
            return [
              {
                name: '查看资源详情',
                onClick: () =>
                  this.$router.push(
                    `/resourceManagement/resource/detail?id=${records.id}&type=view`
                  )
              },
              {
                name: '审核',
                onClick: () =>
                  this.$router.push(
                    `/resourceManagement/resource/detail?id=${records.id}&type=audit&level=town`
                  )
              }
            ]
          }
        }
      ]
    },
    getButton() {
      console.log('test 更新', this.records)
      return [
        {
          viewType: 'menu',
          name: '更多操作',
          isBatch: true,
          children: [
            {
              name: '审核同意',
              type: 'primary',
              onClick: data => {
                let idList = data.map(e => e.id)
                return api.command.editPost.call(this, {
                  url: '/farmHousingResourcesStreetAudit/audit',
                  params: {
                    id: idList.join(','),
                    status: '0'
                  }
                })
              }
            },
            {
              name: '审核驳回',
              type: 'danger',
              onClick: data => {
                let idList = data.map(e => e.id)
                return api.command.editPost.call(this, {
                  url: '/farmHousingResourcesStreetAudit/audit',
                  params: {
                    id: idList.join(','),
                    status: '1'
                  }
                })
              }
            }
          ]
        }
      ]
    }
  },
  render() {
    return (
      <div>
        <TemplateHeaderTable
          headerData={this.getHeader()}
          tableColumns={this.getColumns()}
          button={this.getButton()}
          records={this.records}
        />
      </div>
    )
  }
}
</script>
